import { Route } from "react-router";
import { ProtectedRoute } from "./components";
import {
  AddCompany,
  CompanyList,
  CompanyLocations,
  DataLimits,
  PartnersList,
  SystemSettings,
  TenantList,
  UsersList,
} from "@/pages";
import React, { ReactElement } from "react";
import { SubscriptionsList } from "@/components";
import {
  permissionsPartnersReadonly,
  permissionsSubscriptionsFull,
  permissionsUsersReadonly,
  permissionsCompaniesFull,
  permissionsSubscriptionsReadonly,
  permissionsTenantsFull,
  permissionsSettings,
} from "@/utils";
import { userRoutes } from "./userRoutes";
import { roleRoutes } from "./roleRoutes";
import { subscriptionRoutes } from "./subscriptionRoutes";
import { partnerRoutes } from "./partnerRoutes";
import { tenantRoutes } from "./tenantRoutes";
import { companyRoutes } from "./companyRoutes";
import { locationRoutes } from "./locationRoutes";

const parentPath = "system-admin";

/**
 * Route definitions for system administration routes.
 * Provides full system-level management of users, partners, tenants, companies, roles, and features.
 */
export const systemRoutes: ReactElement[] = [
  <Route
    key="system-settings"
    path="settings"
    element={
      <ProtectedRoute
        element={<SystemSettings />}
        codes={permissionsSettings}
      />
    }
  />,
  <Route
    key="all-users"
    path="all-users"
    element={
      <ProtectedRoute
        element={
          <UsersList
            showAdd
            showEdit
            showChangePassword
            // showSystemRoles
            showLogin
            showProfile
            // showCompanies
            userFilter="all"
            parentPath={parentPath}
          />
        }
        codes={permissionsUsersReadonly}
      />
    }
  />,

  // <Route
  //   key="all-users-profile"
  //   path="all-users/:userId/profile"
  //   element={
  //     <ProtectedRoute
  //       element={<UserProfile />}
  //       codes={permissionsUsersReadonly}
  //     />
  //   }
  // />,

  <Route
    key="system-users"
    path="system-users"
    element={
      <ProtectedRoute
        element={
          <UsersList showEdit userFilter="system" parentPath={parentPath} />
        }
        codes={permissionsUsersReadonly}
      />
    }
  />,

  // <Route
  //   key="roles"
  //   path="roles"
  //   element={
  //     <ProtectedRoute
  //       element={<RolesListPage parentPath={parentPath} showPermissions />}
  //       codes={permissionsRolesReadonly}
  //     />
  //   }
  // />,

  // <Route
  //   key="roles-permissions-key"
  //   path="roles/permissions/:key"
  //   element={
  //     <ProtectedRoute
  //       element={<ModulesList parentPath={parentPath} />}
  //       codes={permissionsRolesFull}
  //     />
  //   }
  // />,

  // <Route
  //   key="subscriptions-features-key"
  //   path="subscriptions/features/:key"
  //   element={
  //     <ProtectedRoute
  //       element={<FeaturesList />}
  //       codes={permissionsSubscriptionsFull}
  //     />
  //   }
  // />,

  // <Route
  //   key="all-users-customers"
  //   path="all-users/:uid/customers"
  //   element={
  //     <ProtectedRoute
  //       element={<SystemAllUserCustomers />}
  //       codes={permissionsUsersReadonly}
  //     />
  //   }
  // />,

  // <Route
  //   key="system-roles"
  //   path="all-users/:uid/system-roles"
  //   element={
  //     <ProtectedRoute
  //       element={<RolesListPage parentPath={parentPath} />}
  //       codes={permissionsRolesReadonly}
  //     />
  //   }
  // />,

  <Route
    key="partners"
    path="partners"
    element={
      <ProtectedRoute
        element={
          <PartnersList
            parentPath={parentPath}
            partnerFilter="all"
            // showAdd
            // showEdit
            showTenants
          />
        }
        codes={permissionsPartnersReadonly}
      />
    }
  />,

  // <Route
  //   key="partners-users"
  //   path="partners/:partnerId/users"
  //   element={
  //     <ProtectedRoute
  //       element={<UsersList userFilter="partner" parentPath={parentPath} />}
  //       codes={permissionsUsersReadonly}
  //     />
  //   }
  // />,

  // <Route
  //   key="partners-users-profile"
  //   path="partners/:partnerId/users/:userId/profile"
  //   element={
  //     <ProtectedRoute
  //       element={<UserProfile />}
  //       codes={permissionsUsersReadonly}
  //     />
  //   }
  // />,

  // <Route
  //   key="partners-tenants"
  //   path="partners/:partnerId/tenants"
  //   element={
  //     <ProtectedRoute
  //       element={<TenantList parentPath={parentPath} />}
  //       codes={permissionsTenantsReadonly}
  //     />
  //   }
  // />,

  <Route
    key="tenants"
    path="tenants"
    element={
      <ProtectedRoute
        element={
          <TenantList showAdd showEdit showDelete parentPath={parentPath} />
        }
        codes={permissionsTenantsFull}
      />
    }
  />,

  // <Route
  //   key="tenants-users"
  //   path="tenants/:tenantId/users"
  //   element={
  //     <ProtectedRoute
  //       element={<UsersList userFilter="tenant" parentPath={parentPath} />}
  //       codes={permissionsUsersFull}
  //     />
  //   }
  // />,

  // <Route
  //   key="tenants-users-profile"
  //   path="tenants/:tenantId/users/:userId/profile"
  //   element={
  //     <ProtectedRoute element={<UserProfile />} codes={permissionsUsersFull} />
  //   }
  // />,

  // <Route
  //   key="tenants-companies"
  //   path="tenants/:tenantId/companies"
  //   element={
  //     <ProtectedRoute
  //       element={
  //         <CompanyList
  //           companyFilter="tenant"
  //           parentPath={parentPath}
  //           parentChildfilter="all"
  //         />
  //       }
  //       codes={permissionsCompaniesFull}
  //     />
  //   }
  // />,

  <Route
    key="companies"
    path="companies"
    element={
      <ProtectedRoute
        element={
          <CompanyList
            parentPath={parentPath}
            companyFilter="all"
            parentChildfilter="parent"
            showAdd
            showEdit
          />
        }
        codes={permissionsCompaniesFull}
      />
    }
  />,

  <Route
    key="locations"
    path="locations"
    element={
      <ProtectedRoute
        element={<CompanyLocations />}
        codes={permissionsCompaniesFull}
      />
    }
  />,

  // <Route
  //   key="tenants-locations"
  //   path="tenants/:tenantId/locations"
  //   element={
  //     <ProtectedRoute
  //       element={<CompanyLocations />}
  //       codes={permissionsCompaniesFull}
  //     />
  //   }
  // />,

  // <Route
  //   key="companies-child-companies"
  //   path="companies/:customerId/child-companies"
  //   element={
  //     <ProtectedRoute
  //       element={<SubsidiaryList parentPath={parentPath} />}
  //       codes={permissionsCompaniesFull}
  //     />
  //   }
  // />,

  // <Route
  //   key="tenants-companies-child-companies"
  //   path="tenants/:tenantId/companies/:customerId/child-companies"
  //   element={
  //     <ProtectedRoute
  //       element={<SubsidiaryList parentPath={parentPath} />}
  //       codes={permissionsCompaniesFull}
  //     />
  //   }
  // />,

  <Route
    key="add-company"
    path="companies/add"
    element={
      <ProtectedRoute
        element={<AddCompany />}
        codes={permissionsCompaniesFull}
      />
    }
  />,

  <Route
    key="edit-company"
    path="companies/edit/:id"
    element={
      <ProtectedRoute
        element={<AddCompany />}
        codes={permissionsCompaniesFull}
      />
    }
  />,

  <Route
    key="edit-company-alt"
    path="companies/:id/edit"
    element={
      <ProtectedRoute
        element={<AddCompany />}
        codes={permissionsCompaniesFull}
      />
    }
  />,

  <Route
    key="subscriptions"
    path="subscriptions"
    element={
      <ProtectedRoute
        element={
          <SubscriptionsList
            parentPath={parentPath}
            // showAdd
            // showEdit
            // showDelete
            showFeatures
          />
        }
        codes={permissionsSubscriptionsReadonly}
      />
    }
  />,

  // <Route
  //   key="features"
  //   path="features"
  //   element={
  //     <ProtectedRoute
  //       element={<DeveloperFeatures />}
  //       codes={permissionsDeveloper}
  //     />
  //   }
  // />,

  <Route
    key="data-limits"
    path="data-limits"
    element={
      <ProtectedRoute
        element={
          <DataLimits showAdd showEdit showDelete parentPath={parentPath} />
        }
        codes={permissionsSubscriptionsFull}
      />
    }
  />,
  // <Route
  //   key="documents"
  //   path="documents"
  //   element={
  //     <ProtectedRoute
  //       element={<AddDocument parentPath={parentPath} />}
  //       codes={permissionsDocumentsFull}
  //     />
  //   }
  // />,
  // <Route
  //   key="documents-add"
  //   path="documents/add"
  //   element={
  //     <ProtectedRoute
  //       element={<AddDocument parentPath={parentPath} />}
  //       codes={permissionsDocumentsFull}
  //     />
  //   }
  // />,
  // <Route
  //   key="documents-view"
  //   path="documents/view/:id"
  //   element={
  //     <ProtectedRoute
  //       element={<DocumentView />}
  //       codes={permissionsDocumentsReadonly}
  //     />
  //   }
  // />,
  // <Route
  //   key="documents-edit"
  //   path="documents/edit/:id"
  //   element={
  //     <ProtectedRoute
  //       element={<AddDocument parentPath={parentPath} />}
  //       codes={permissionsDocumentsFull}
  //     />
  //   }
  // />,
  <Route path="all-users/:userId">{userRoutes(parentPath)}</Route>,
  <Route path="roles">{roleRoutes(parentPath)}</Route>,
  <Route path="subscriptions">{subscriptionRoutes(parentPath)}</Route>,
  <Route path="partners/:partnerId">{partnerRoutes(parentPath)}</Route>,
  <Route path="tenants/:tenantId">{tenantRoutes(parentPath)}</Route>,
  <Route path="companies/:customerId">
    {companyRoutes(parentPath, { showAddCompany: true, showEditCompany: true })}
  </Route>,
  <Route path="locations">{locationRoutes(parentPath)}</Route>,
];
